module.exports = __webpack_public_path__ + "static/headshot-emily-08dec25fd043fac573e885dc26ff6c46.avif";